import { GetterTree } from "vuex";
import { HomeState, RootState, HomeCourse } from "@/interface";
import {
  courseInfoGetter,
  reservationGetter,
  courseListGetter
} from "./getter-types";

export const getters: GetterTree<HomeState, RootState> = {
  [courseInfoGetter]: (state: HomeState) => (id: string, type: string) => {
    if (state.homeResources.courseGroup) {
      for (const key in state.homeResources.courseGroup) {
        const group = state.homeResources.courseGroup[key];
        if (group.courses && (!type || type === group.type)) {
          const course = group.courses.find(
            (detail: HomeCourse) => detail.course_id === id
          );
          if (course) {
            return course;
          }
        }
      }
    }
    return undefined;
  },
  [reservationGetter]: (state: HomeState) => (courseId: string) => {
    if (state.homeResources.reservationsMap) {
      return state.homeResources.reservationsMap[courseId];
    }
    return undefined;
  },
  [courseListGetter]: (state: HomeState): any[] => {
    if (state.homeResources.courseGroup) {
      return state.homeResources.courseGroup.reduce((list: any[], group) => {
        const courses = group.courses.map(course => ({
          key: `courseId=${course.course_id}&courseType=${course.course_type}`,
          label: `${course.course_type}: ${course.course}`
        }));
        return [...list, ...courses];
      }, []);
    }
    return [];
  }
};
